import { render, staticRenderFns } from "./EditProfileFormDb.vue?vue&type=template&id=28c61942&"
import script from "./EditProfileFormDb.vue?vue&type=script&lang=js&"
export * from "./EditProfileFormDb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports